<template>
  <div class="big testDoctorPrescribing">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">测试医生开方监测记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div
        class="container"
        style="padding: 10px 20px 20px 20px;"
      >

        <div class="search-box">

          <!-- 处方号 -->
          <div class="item">
            <span style="width: 70px;">处方号</span>
            <div class="item-content">
              <el-input
                v-model="prescriptionForm.pre_id"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="处方号"
              ></el-input>
            </div>
          </div>

          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="prescriptionForm.doctor_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="医生"
              ></el-input>
            </div>
          </div>

          <!-- 医生手机号 -->
          <div class="item">
            <span>医生手机号</span>
            <div class="item-content">
              <el-input
                v-model="prescriptionForm.doctor_phone"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="医生手机号"
              ></el-input>
            </div>
          </div>

          <!-- 患者姓名 -->
          <div class="item">
            <span style="width: 70px;">患者姓名</span>
            <div class="item-content">
              <el-input
                v-model="prescriptionForm.user_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="患者"
              ></el-input>
            </div>
          </div>

          <!-- 药房名称 -->
          <div class="item">
            <span>药房名称</span>
            <div class="item-content">
              <el-input
                v-model="prescriptionForm.hospital_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="药房名称"
              ></el-input>
            </div>
          </div>

          <!-- 开方时间 -->
          <div class="item">
            <span style="width: 70px;">开方时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="prescriptionForm.create_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 处方类型 -->
          <div class="item">
            <span>处方类型</span>
            <div class="item-content">
              <el-select
                v-model="prescriptionForm.pre_group"
                placeholder="请选择"
                clearable
                size="small"
                @change="getList"
              >
                <el-option
                  v-for="(item, index) in pre_group_list"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- 药品剂型 -->
          <div class="item">
            <span>药品剂型</span>
            <div class="item-content">
              <el-select
                v-model="prescriptionForm.drug_type"
                placeholder="请选择"
                size="small"
                @change="getList"
                clearable
              >
                <el-option
                  v-for="item in drug_type_list"
                  :key="item.drug_type"
                  :label="item.drug_type_name"
                  :value="item.drug_type"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- 处方状态 -->
          <div class="item">
            <span>处方状态</span>
            <div class="item-content">
              <el-select
                v-model="prescriptionForm.status"
                placeholder="请选择"
                size="small"
                clearable
                @change="getList"
              >
                <el-option
                  v-for="(item, index) in status_list"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- 是否代煎 -->
          <div class="item">
            <span>是否代煎</span>
            <div class="item-content">
              <el-radio-group
                v-model="prescriptionForm.drug_machining"
                size="small"
                @change="getList"
              >
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left:20px"
              @click="getList"
            >查询</el-button>
            <el-button
              size="small"
              @click="restBtn"
            >重置</el-button>
          </div>

        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table
            v-loading="tableLoading"
            :data="prescriptionData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'user_info'">
                  <div>{{ scope.row.user_name }}</div>
                  <div>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <span v-if="!scope.row.sex">未知</span>
                    <span style="margin-left: 10px">{{ scope.row.age }}</span>
                  </div>
                </div>

                <div v-else-if="item.prop == 'doctor_info'">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer"
                  >{{ scope.row.doctor_name }}</div>
                  <div>
                    <span v-if="scope.row.doctor_sex == 1">男</span>
                    <span v-if="scope.row.doctor_sex == 2">女</span>
                    <span v-if="!scope.row.doctor_sex">未知</span>
                    <span style="margin-left: 10px">{{ scope.row.d_age }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </div>

                <div v-else-if="item.prop == 'pre_group'">
                  {{ scope.row[item.prop] | preGroupText }}
                </div>

                <div v-else-if="item.prop == 'status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>
                <div v-else>
                  {{ JSON.stringify(scope.row[item.prop]) === 'null' ? '' : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="toDetail(scope.row)"
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum>0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import systemWarning from '@/api/systemWarning.js';
import Pagination from '@/components/Pagination/index';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  components: {
    Pagination,
    DocMsg
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      prescriptionForm: {
        pre_id: '',
        doctor_name: '',
        doctor_phone: '',
        user_name: '',
        hospital_name: '',
        create_time: [],
        pre_group: '',
        drug_type: '',
        status: '',
        drug_machining: ''
      },
      pre_group_list: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '中药材',
          value: 1
        },
        {
          label: '养生方',
          value: 2
        },
        {
          label: '成药',
          value: 3
        }
      ],
      drug_type_list: [],
      status_list: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '待取药',
          value: 1
        },
        {
          label: '待审方',
          value: 2
        },
        {
          label: '已通过',
          value: 3
        },
        {
          label: '已抓药',
          value: 4
        },
        {
          label: '过期未取药',
          value: 5
        },
        {
          label: '审方不通过',
          value: 6
        },
        {
          label: '医生手动作废',
          value: 7
        },
        {
          label: '平台退款',
          value: 8
        }
      ],
      tableHeader: [
        {
          label: '开方时间',
          prop: 'create_time',
          width: 'auto',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '处方号',
          prop: 'pre_id',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '患者信息',
          prop: 'user_info',
          width: '120',
          align: 'center',
          fixed: false
        },
        {
          label: '医生信息',
          prop: 'doctor_info',
          width: '120',
          align: 'center',
          fixed: false
        },
        {
          label: '药房名称',
          prop: 'hospital_name',
          width: '110',
          align: 'center',
          fixed: false
        },
        {
          label: '处方类型/药品剂型',
          prop: 'pre_group',
          width: '140',
          align: 'center',
          fixed: false
        },
        {
          label: '药品金额',
          prop: 'drug_price',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '诊后管理费',
          prop: 'consult_drug_price',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '诊金',
          prop: 'consulting_gold',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '辅料',
          prop: 'excipients_price',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '加工费',
          prop: 'drug_machining_price',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '处方状态',
          prop: 'status',
          width: '200',
          align: 'center',
          fixed: false
        }
      ],
      prescriptionData: [],
      doc_msg: false,
      doctorId: ''
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    preGroupText(val) {
      switch (val) {
        case -1:
          return '成药';
        case 0:
          return '养生膏方';
        case 1:
          return '颗粒';
        case 2:
          return '饮片';
        case 3:
          return '膏方';
        case 4:
          return '丸剂';
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return '待取药';
        case 2:
          return '待审方';
        case 3:
          return '已通过';
        case 4:
          return '已抓药';
        case 5:
          return '已失效[过期未取药]';
        case 6:
          return '已失效[审方不通过]';
        case 7:
          return '已失效[医生手动作废]';
        case 8:
          return '已失效[平台退款]';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    scTimeOptions() {
      let arr = [];
      for (let i = 1; i <= 30; i++) {
        arr.push({
          value: i,
          label: `${i}天`
        });
      }
      return arr;
    }
  },
  created() {
    // this.initCompletionTime();
    this.getDrugTypeList();
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post('platform/photograph/getDrugTypeList', { platform_type })
        .then((res) => {
          this.drug_type_list = res.data.list;
        });
    },
    initCompletionTime() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format('YYYY-MM-DD');
      start = dayjs(start).format('YYYY-MM-DD');
      this.prescriptionForm.create_time = [start, end];
    },
    getList() {
      let params = Object.assign(this.pagination, this.prescriptionForm);
      params = _.omit(params, ['create_time']);
      let create_time = this.prescriptionForm.create_time;
      params['create_time_start'] = create_time ? create_time[0] : '';
      params['create_time_end'] = create_time ? create_time[1] : '';

      this.tableLoading = true;
      systemWarning.testDoctorPrescription(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.prescriptionData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    toDetail(row) {
      this.$router.push({
        path: '/home/yewu/chufangdetail',
        query: {
          pre_id: row.pre_id
        }
      });
    },
    restBtn() {
      for (let key in this.prescriptionForm) {
        if (key == 'create_time') {
          this.prescriptionForm[key] = [];
        } else {
          this.prescriptionForm[key] = '';
        }
      }
      // this.initCompletionTime();
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.testDoctorPrescribing {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>